module.exports = __webpack_public_path__ + "img/user-profile.a2ff0995.jpg";